<template>
  <div class="d-flex">
    <SideBar
      class="side-bar"
      :class="{ 'is-visible': isHide }"
      @handleClick="isHide = !isHide"
      :isHide="isHide"
    >
      <!-- <svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg"> -->
      <!-- <path id="nlt" stroke-width="3" d="M469.482 178.471C469.482 178.607 469.482 178.763 469.443 178.899V178.937L466.044 195.466V195.505L465.442 198.437C464.84 200.69 463.907 202.827 462.703 204.769C462.703 204.789 462.684 204.808 462.664 204.827C460.45 208.945 456.799 212.189 452.37 213.859C450.584 214.539 448.641 214.946 446.641 215.082C446.272 215.102 445.883 215.121 445.495 215.121C445.106 215.121 444.737 215.121 444.349 215.082H415.468L415.293 215.859H415.254L393.714 320.216C393.714 320.216 393.695 320.332 393.676 320.39C391.831 329.15 384.081 335.753 374.758 335.753H353.743C352.5 335.753 351.49 334.744 351.49 333.5C351.49 333.365 351.49 333.248 351.529 333.131C351.529 333.093 351.529 333.034 351.568 332.996L355.142 315.671L366.795 259.462L366.834 259.21L375.807 215.879V215.84L375.962 215.102H349.101C348.907 215.102 348.732 215.121 348.557 215.121C348.363 215.121 348.188 215.102 348.013 215.102H327.562C326.319 215.102 325.309 214.092 325.309 212.849C325.309 212.713 325.309 212.596 325.347 212.48C325.347 212.441 325.347 212.383 325.386 212.344L329.193 193.465C329.232 193.31 329.29 193.155 329.329 192.98C329.329 192.98 329.329 192.96 329.329 192.941V192.902C329.465 191.97 329.659 191.076 329.931 190.202C329.931 190.183 329.931 190.144 329.951 190.125C329.951 190.105 329.951 190.086 329.951 190.066L331.019 187.27C331.019 187.27 331.019 187.231 331.038 187.231C331.038 187.231 331.038 187.231 331.038 187.211C334.165 180.744 340.827 176.277 348.499 176.277C348.654 176.277 348.81 176.296 348.965 176.296C349.023 176.296 349.082 176.296 349.14 176.277H444.563C444.854 176.277 445.165 176.257 445.456 176.257C445.747 176.257 446.039 176.257 446.311 176.277H467.403C468.549 176.393 469.423 177.364 469.423 178.53L469.482 178.471Z" fill="#E3282C"/> -->
      <!-- <path id="nlt" d="M215.572 178.43C215.572 178.43 215.572 178.566 215.572 178.624C215.572 178.682 215.572 178.76 215.533 178.818L215.494 179.032V179.071L214.173 185.092L185.681 315.843C185.486 316.717 185.214 317.591 184.923 318.426L184.748 319.203L184.496 320.291C182.767 328.739 175.523 335.188 166.685 335.693H142.446C142.446 335.693 142.31 335.693 142.252 335.654L101.523 243.3L86.7425 311.609L84.9168 319.708C83.3047 328.739 75.4192 335.634 65.9022 335.634C65.7663 335.634 65.6109 335.634 65.4555 335.615C65.3972 335.615 65.339 335.615 65.2807 335.615H44.5375C43.411 335.498 42.5176 334.527 42.5176 333.362C42.5176 333.226 42.5176 333.109 42.5564 332.993C42.5564 332.993 42.5564 332.876 42.5953 332.838L46.8294 313.182C46.9265 312.599 47.043 312.017 47.1984 311.434L70.7773 202.067H70.7384L72.6807 193.191C72.6807 193.171 72.6807 193.152 72.6807 193.133L72.972 191.792L73.477 189.423L74.4675 186.879C74.4675 186.879 74.4675 186.84 74.487 186.84C74.487 186.84 74.487 186.84 74.487 186.82C77.3809 180.819 83.3242 176.565 90.2968 176.002H114.672C115.488 176.099 116.168 176.565 116.537 177.245L156.761 268.685L158.878 256.1L172.939 192.608V192.569C173.075 191.656 173.27 190.744 173.542 189.87C173.542 189.85 173.542 189.811 173.561 189.792C173.561 189.772 173.561 189.753 173.561 189.734L174.629 186.956C174.629 186.956 174.629 186.917 174.649 186.917C174.649 186.917 174.649 186.917 174.649 186.898C177.756 180.469 184.379 176.021 192.012 176.021C192.498 176.021 192.983 176.041 193.45 176.08H193.547C193.547 176.08 193.683 176.08 193.76 176.08H213.241C213.241 176.08 213.396 176.08 213.474 176.08C214.62 176.196 215.494 177.167 215.494 178.333L215.572 178.43Z M469.482 178.471C469.482 178.607 469.482 178.763 469.443 178.899V178.937L466.044 195.466V195.505L465.442 198.437C464.84 200.69 463.907 202.827 462.703 204.769C462.703 204.789 462.684 204.808 462.664 204.827C460.45 208.945 456.799 212.189 452.37 213.859C450.584 214.539 448.641 214.946 446.641 215.082C446.272 215.102 445.883 215.121 445.495 215.121C445.106 215.121 444.737 215.121 444.349 215.082H415.468L415.293 215.859H415.254L393.714 320.216C393.714 320.216 393.695 320.332 393.676 320.39C391.831 329.15 384.081 335.753 374.758 335.753H353.743C352.5 335.753 351.49 334.744 351.49 333.5C351.49 333.365 351.49 333.248 351.529 333.131C351.529 333.093 351.529 333.034 351.568 332.996L355.142 315.671L366.795 259.462L366.834 259.21L375.807 215.879V215.84L375.962 215.102H349.101C348.907 215.102 348.732 215.121 348.557 215.121C348.363 215.121 348.188 215.102 348.013 215.102H327.562C326.319 215.102 325.309 214.092 325.309 212.849C325.309 212.713 325.309 212.596 325.347 212.48C325.347 212.441 325.347 212.383 325.386 212.344L329.193 193.465C329.232 193.31 329.29 193.155 329.329 192.98C329.329 192.98 329.329 192.96 329.329 192.941V192.902C329.465 191.97 329.659 191.076 329.931 190.202C329.931 190.183 329.931 190.144 329.951 190.125C329.951 190.105 329.951 190.086 329.951 190.066L331.019 187.27C331.019 187.27 331.019 187.231 331.038 187.231C331.038 187.231 331.038 187.231 331.038 187.211C334.165 180.744 340.827 176.277 348.499 176.277C348.654 176.277 348.81 176.296 348.965 176.296C349.023 176.296 349.082 176.296 349.14 176.277H444.563C444.854 176.277 445.165 176.257 445.456 176.257C445.747 176.257 446.039 176.257 446.311 176.277H467.403C468.549 176.393 469.423 177.364 469.423 178.53L469.482 178.471Z M338.692 299.274C338.692 299.41 338.693 299.546 338.654 299.682V299.76L334.206 320.095C334.206 320.114 334.206 320.153 334.206 320.173C334.206 320.231 334.187 320.289 334.167 320.347C334.109 320.619 334.051 320.891 333.973 321.163C333.157 324.349 331.564 327.204 329.389 329.534L329.35 329.573C326.476 332.642 322.591 334.778 318.241 335.458C317.464 335.652 317.017 335.691 317.017 335.691H204.095C202.852 335.691 201.842 334.681 201.842 333.438C201.842 333.302 201.842 333.186 201.881 333.069C201.881 333.03 201.881 332.972 201.919 332.933L213.32 279.677L213.379 279.638L213.534 278.939L213.767 277.832L231.733 193.578C231.733 193.578 231.772 193.422 231.791 193.364C231.947 192.84 232.121 192.315 232.296 191.81C234.005 182.895 241.852 176.156 251.272 176.156C251.563 176.156 251.855 176.195 252.146 176.195C252.321 176.175 252.515 176.156 252.69 176.156H272.559C273.705 176.272 274.579 177.244 274.579 178.409C274.579 178.545 274.579 178.681 274.54 178.817V178.894L274.501 178.992C274.501 178.992 274.501 179.011 274.501 179.03L273.2 185.148L270.325 198.569C270.228 199.23 270.073 199.871 269.918 200.512L249.621 296.089H249.679L249.466 297.06H336.439C336.439 297.06 336.595 297.06 336.673 297.06C337.818 297.177 338.692 298.148 338.692 299.313V299.274Z M430.503 319.781C430.328 319.587 430.173 319.393 429.959 319.257C429.629 319.024 429.26 318.907 428.891 318.752C428.327 318.538 427.745 318.48 427.143 318.48C425.55 318.48 423.957 318.48 422.365 318.48H422.287V318.558C422.287 322.19 422.287 325.822 422.287 329.454C422.287 329.531 422.287 329.551 422.384 329.551H424.055C424.055 329.551 424.113 329.551 424.152 329.551V325.492H424.19C424.948 325.492 425.725 325.492 426.482 325.492C426.502 325.492 426.541 325.492 426.56 325.53C426.677 325.725 426.793 325.899 426.91 326.074C427.628 327.201 428.366 328.347 429.085 329.473C429.104 329.531 429.143 329.551 429.202 329.551H430.872C430.872 329.551 430.93 329.551 430.969 329.551C430.076 328.152 429.182 326.754 428.289 325.356C428.425 325.336 428.541 325.297 428.658 325.259C429.24 325.103 429.784 324.889 430.231 324.482C430.522 324.229 430.775 323.957 430.911 323.588C431.008 323.355 431.066 323.083 431.124 322.85C431.183 322.539 431.221 322.229 431.221 321.918C431.221 321.529 431.124 321.18 431.047 320.811C430.949 320.422 430.755 320.092 430.503 319.801V319.781ZM429.299 322.52C429.201 322.908 428.93 323.2 428.619 323.433C428.463 323.549 428.289 323.608 428.114 323.646C427.9 323.724 427.687 323.782 427.492 323.841C427.318 323.88 427.143 323.918 426.968 323.918C426.036 323.918 425.103 323.918 424.19 323.918C424.19 323.918 424.171 323.918 424.152 323.918V319.956H424.229C425.123 319.956 425.997 319.956 426.871 319.956C427.084 319.956 427.298 320.014 427.512 320.034C427.609 320.034 427.725 320.034 427.823 320.073C427.978 320.112 428.153 320.17 428.289 320.248C428.502 320.364 428.716 320.519 428.91 320.675C429.143 320.869 429.26 321.122 429.318 321.413C429.396 321.782 429.376 322.17 429.279 322.539L429.299 322.52Z M437.512 320.754C437.279 319.919 436.969 319.142 436.561 318.384C436.094 317.51 435.531 316.714 434.89 315.976C434.424 315.452 433.919 314.985 433.356 314.558C432.326 313.762 431.2 313.14 429.976 312.694C429.335 312.461 428.694 312.286 428.015 312.169C427.607 312.111 427.199 312.072 426.791 312.033C426.675 312.033 426.558 312.033 426.422 312.014H425.509C425.509 312.014 425.451 312.014 425.412 312.014C425.14 312.033 424.888 312.033 424.616 312.092C424.188 312.15 423.742 312.208 423.295 312.305C422.557 312.461 421.838 312.713 421.12 313.024C420.013 313.509 419.022 314.15 418.09 314.927C417.468 315.471 416.905 316.073 416.4 316.734C415.584 317.802 414.963 318.967 414.535 320.249C414.205 321.24 414.011 322.23 413.953 323.279C413.914 323.862 413.914 324.425 413.972 325.007C414.011 325.376 414.05 325.745 414.108 326.114C414.283 327.086 414.574 327.998 414.982 328.911C415.448 329.96 416.05 330.892 416.789 331.766C417.274 332.33 417.798 332.854 418.381 333.32C419.197 333.981 420.071 334.524 421.042 334.952C422.149 335.437 423.295 335.767 424.499 335.903C424.888 335.942 425.276 335.981 425.665 336C426.189 336 426.713 336 427.218 335.923C427.665 335.864 428.131 335.806 428.578 335.709C429.685 335.476 430.714 335.068 431.705 334.524C432.54 334.078 433.298 333.534 433.997 332.893C434.58 332.368 435.104 331.766 435.57 331.145C436.133 330.387 436.599 329.572 436.968 328.737C437.338 327.882 437.59 326.989 437.745 326.076C437.842 325.493 437.901 324.91 437.92 324.308C437.92 323.706 437.92 323.123 437.823 322.521C437.745 321.919 437.629 321.356 437.473 320.773L437.512 320.754ZM425.956 334.155C420.343 334.155 415.817 329.611 415.837 323.997C415.837 318.346 420.401 313.859 425.995 313.859C431.666 313.859 436.133 318.462 436.133 324.017C436.133 329.649 431.569 334.155 425.975 334.155H425.956Z" fill="#E3282C"/> -->
      <!-- <path d="M338.692 299.274C338.692 299.41 338.693 299.546 338.654 299.682V299.76L334.206 320.095C334.206 320.114 334.206 320.153 334.206 320.173C334.206 320.231 334.187 320.289 334.167 320.347C334.109 320.619 334.051 320.891 333.973 321.163C333.157 324.349 331.564 327.204 329.389 329.534L329.35 329.573C326.476 332.642 322.591 334.778 318.241 335.458C317.464 335.652 317.017 335.691 317.017 335.691H204.095C202.852 335.691 201.842 334.681 201.842 333.438C201.842 333.302 201.842 333.186 201.881 333.069C201.881 333.03 201.881 332.972 201.919 332.933L213.32 279.677L213.379 279.638L213.534 278.939L213.767 277.832L231.733 193.578C231.733 193.578 231.772 193.422 231.791 193.364C231.947 192.84 232.121 192.315 232.296 191.81C234.005 182.895 241.852 176.156 251.272 176.156C251.563 176.156 251.855 176.195 252.146 176.195C252.321 176.175 252.515 176.156 252.69 176.156H272.559C273.705 176.272 274.579 177.244 274.579 178.409C274.579 178.545 274.579 178.681 274.54 178.817V178.894L274.501 178.992C274.501 178.992 274.501 179.011 274.501 179.03L273.2 185.148L270.325 198.569C270.228 199.23 270.073 199.871 269.918 200.512L249.621 296.089H249.679L249.466 297.06H336.439C336.439 297.06 336.595 297.06 336.673 297.06C337.818 297.177 338.692 298.148 338.692 299.313V299.274Z" fill="#E3282C"/> -->
      <!-- <path d="M430.503 319.781C430.328 319.587 430.173 319.393 429.959 319.257C429.629 319.024 429.26 318.907 428.891 318.752C428.327 318.538 427.745 318.48 427.143 318.48C425.55 318.48 423.957 318.48 422.365 318.48H422.287V318.558C422.287 322.19 422.287 325.822 422.287 329.454C422.287 329.531 422.287 329.551 422.384 329.551H424.055C424.055 329.551 424.113 329.551 424.152 329.551V325.492H424.19C424.948 325.492 425.725 325.492 426.482 325.492C426.502 325.492 426.541 325.492 426.56 325.53C426.677 325.725 426.793 325.899 426.91 326.074C427.628 327.201 428.366 328.347 429.085 329.473C429.104 329.531 429.143 329.551 429.202 329.551H430.872C430.872 329.551 430.93 329.551 430.969 329.551C430.076 328.152 429.182 326.754 428.289 325.356C428.425 325.336 428.541 325.297 428.658 325.259C429.24 325.103 429.784 324.889 430.231 324.482C430.522 324.229 430.775 323.957 430.911 323.588C431.008 323.355 431.066 323.083 431.124 322.85C431.183 322.539 431.221 322.229 431.221 321.918C431.221 321.529 431.124 321.18 431.047 320.811C430.949 320.422 430.755 320.092 430.503 319.801V319.781ZM429.299 322.52C429.201 322.908 428.93 323.2 428.619 323.433C428.463 323.549 428.289 323.608 428.114 323.646C427.9 323.724 427.687 323.782 427.492 323.841C427.318 323.88 427.143 323.918 426.968 323.918C426.036 323.918 425.103 323.918 424.19 323.918C424.19 323.918 424.171 323.918 424.152 323.918V319.956H424.229C425.123 319.956 425.997 319.956 426.871 319.956C427.084 319.956 427.298 320.014 427.512 320.034C427.609 320.034 427.725 320.034 427.823 320.073C427.978 320.112 428.153 320.17 428.289 320.248C428.502 320.364 428.716 320.519 428.91 320.675C429.143 320.869 429.26 321.122 429.318 321.413C429.396 321.782 429.376 322.17 429.279 322.539L429.299 322.52Z" fill="#E3282C"/> -->
      <!-- <path d="M437.512 320.754C437.279 319.919 436.969 319.142 436.561 318.384C436.094 317.51 435.531 316.714 434.89 315.976C434.424 315.452 433.919 314.985 433.356 314.558C432.326 313.762 431.2 313.14 429.976 312.694C429.335 312.461 428.694 312.286 428.015 312.169C427.607 312.111 427.199 312.072 426.791 312.033C426.675 312.033 426.558 312.033 426.422 312.014H425.509C425.509 312.014 425.451 312.014 425.412 312.014C425.14 312.033 424.888 312.033 424.616 312.092C424.188 312.15 423.742 312.208 423.295 312.305C422.557 312.461 421.838 312.713 421.12 313.024C420.013 313.509 419.022 314.15 418.09 314.927C417.468 315.471 416.905 316.073 416.4 316.734C415.584 317.802 414.963 318.967 414.535 320.249C414.205 321.24 414.011 322.23 413.953 323.279C413.914 323.862 413.914 324.425 413.972 325.007C414.011 325.376 414.05 325.745 414.108 326.114C414.283 327.086 414.574 327.998 414.982 328.911C415.448 329.96 416.05 330.892 416.789 331.766C417.274 332.33 417.798 332.854 418.381 333.32C419.197 333.981 420.071 334.524 421.042 334.952C422.149 335.437 423.295 335.767 424.499 335.903C424.888 335.942 425.276 335.981 425.665 336C426.189 336 426.713 336 427.218 335.923C427.665 335.864 428.131 335.806 428.578 335.709C429.685 335.476 430.714 335.068 431.705 334.524C432.54 334.078 433.298 333.534 433.997 332.893C434.58 332.368 435.104 331.766 435.57 331.145C436.133 330.387 436.599 329.572 436.968 328.737C437.338 327.882 437.59 326.989 437.745 326.076C437.842 325.493 437.901 324.91 437.92 324.308C437.92 323.706 437.92 323.123 437.823 322.521C437.745 321.919 437.629 321.356 437.473 320.773L437.512 320.754ZM425.956 334.155C420.343 334.155 415.817 329.611 415.837 323.997C415.837 318.346 420.401 313.859 425.995 313.859C431.666 313.859 436.133 318.462 436.133 324.017C436.133 329.649 431.569 334.155 425.975 334.155H425.956Z" fill="#E3282C"/> -->
      <!-- </svg> -->
      <b-tabs v-model="currentTab" nav-class="d-none" class="m-0">
        <b-tab class="tab-class" style="position: relative">
          <div class="header-tab">
            <p class="text-color tab-title">{{ $t("list-tree") }}</p>
            <div class="d-flex mb-3">
              <div class="input-group mb-0">
                <div class="input-group-prepend bg-white" style="height: 40px">
                  <p class="input-group-text py-0 pl-3">
                    <img src="@/assets/image/icon/search-lg.svg" />
                  </p>
                </div>
                <input
                  type="text"
                  class="form-control bg-white form-search"
                  placeholder="Tìm kiếm tên, địa chỉ"
                  v-model="search"
                  @input="handleSearch"
                />
              </div>
              <b-button class="my-0 btn-filter" @click="filterModal">
                <img src="assets/image/icon/filter.svg" />
              </b-button>
            </div>
            <div>
              <span>{{ $t("tree-quantity") }}</span>
              <span
                class="float-right"
                style="font-weight: 400; color: var(--labels-primary, #000)"
                ><b class="text-green mr-2">{{ listTreeFilter.length }}</b
                >{{ $t("result") }}</span
              >
            </div>
          </div>
          <div class="content-tab">
            <template v-if="!isLoading">
              <div v-for="(item, index) in listTreeFilter" :key="index">
                <div
                  v-if="index < itemPerView"
                  class="item-card"
                  @click="flytoPointMap(item)"
                >
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-lg-10 col-md-10">
                        <div class="row">
                          <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                            <div
                              class="img-frame"
                              :style="`background-image: url(${item.TreeImage})`"
                            ></div>
                          </div>
                          <div class="col-lg-8 col-md-8 col-sm-8 p-0">
                            <strong class="router-name">
                              {{ item.StationName }}
                            </strong>
                            <p
                              class="mt-2 mb-1 router-info"
                              :style="`color: ${item.StatusColor};`"
                            >
                              <svg
                                class="mb-1"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="Time_solid">
                                  <g id="Group">
                                    <path
                                      id="Vector"
                                      d="M8.00016 14.6666C4.3335 14.6666 1.3335 11.6666 1.3335 7.99992C1.3335 4.33325 4.3335 1.33325 8.00016 1.33325C11.6668 1.33325 14.6668 4.33325 14.6668 7.99992C14.6668 11.6666 11.6668 14.6666 8.00016 14.6666Z"
                                      :fill="`${item.StatusColor}`"
                                    />
                                  </g>
                                </g>
                              </svg>
                              {{ item.StatusName }}
                            </p>
                            <p class="my-1 d-flex">
                              <i class="fas fa-map-marker-alt mr-1"></i>
                              <span
                                class="time-info text-nowrap"
                                style="
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ item.ConcatAddress }}
                              </span>
                            </p>
                            <p class="m-0 time-info">
                              <img
                                src="assets/image/icon/clock-rewind.svg"
                                class="pb-1"
                              />
                              {{ item.UpdateTime }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="text-right col-lg-2 col-md-2 p-0">
                        <p
                          class="m-0 detail-btn"
                          @click="getDetail(item.StationID)"
                        >
                          {{ $t("detail") }}
                        </p>
                        <p class="m-0 router-info">
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="(i, index) in [1, 2, 3, 4, 5]"
                :key="index"
                class="item-card loading"
              >
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12 col-md-10">
                      <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-3 p-0">
                          <div class="img-frame h-100"></div>
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9">
                          <strong class="router-name title-loading w-100">
                          </strong>
                          <strong class="router-name title-loading"> </strong>
                          <strong class="router-name title-loading w-50">
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <b-button
              v-if="listTreeFilter.length > itemPerView"
              active-class="btn-readmore"
              class="w-100 btn-readmore"
              @click="handleReadMore"
              >{{ $t("readmore") }}</b-button
            >
          </div>
        </b-tab>
        <b-tab>
          <RouteDetail
            @action="actionChange"
            @reload="getListComment"
            :dataByID="dataByID"
            :listBusStop="listBusStop"
            :listComment="listComment"
          ></RouteDetail>
        </b-tab>
        <b-tab>
          <StationDetail
            @action="actionChange"
            :stationDetail="stationDetail"
            :listRouteOfStation="listRouteOfStation"
            :listBusOfStation="listBusOfStation"
          ></StationDetail>
        </b-tab>
      </b-tabs>
    </SideBar>
    <Map
      class="map-container"
      ref="mapContainer"
      :data-map="listTree"
      :cqlFilter="cqlFilter"
      @pointClickOnMap="pointClickOnMap"
    ></Map>
    <b-modal
      id="modal-filter-result"
      class="modal-filter-result"
      header-class="pl-3 pt-2 pb-2 pr-3"
      body-class="p-3"
      :size="'xl'"
      centered
      scrollable
      @hidden="resetPopupDataFilter"
      hide-footer
    >
      <template #modal-header="{ close }">
        <strong class="text-info text-green">Tìm kiếm nâng cao</strong>
        <img
          src="/assets/image/icon/x-close.svg"
          class="ml-auto"
          @click="close"
          style="cursor: pointer"
        />
      </template>
      <b-row v-if="filterFormat">
        <template v-for="(filter, index) in filterFormat">
          <template v-if="filter.TypeShow.toUpperCase() == 'TABLE'">
            <b-col xl="12" lg="12" md="12" class="mb-3" :key="index">
              <p class="font-weight-bold text-small mb-2">{{ filter.Title }}</p>
            </b-col>
          </template>
          <template v-else-if="filter.TypeShow.toUpperCase() == 'TREETABLE'">
            <b-col xl="12" lg="12" md="12" class="mb-3" :key="index">
              <p class="font-weight-bold text-small mb-2">{{ filter.Title }}</p>
            </b-col>
          </template>
          <template v-else-if="filter.TypeShow.toUpperCase() == 'SELECT'">
            <b-col xl="8" lg="8" md="12" class="mb-3" :key="index">
              <p class="font-weight-bold text-small mb-2">{{ filter.Title }}</p>
            </b-col>
          </template>
          <template v-else-if="filter.TypeShow.toUpperCase() == 'TREESELECT'">
            <b-col
              xl="8"
              lg="8"
              md="12"
              class="mb-3"
              style="min-height: 300px"
              :key="index"
            >
              <p class="font-weight-bold text-small mb-2">{{ filter.Title }}</p>
              <TreeSelect
                v-model="filterForm[filter.TableName]"
                name="tree-select-input"
                :limit="1"
                :limitText="limitText"
                :multiple="true"
                :alwaysOpen="true"
                :searchable="true"
                :close-on-select="true"
                :options="filterData[filter.TableName]"
                :max-height="230"
                :min-height="200"
                :placeholder="$t('search')"
                :default-expand-level="5"
                :no-results-text="$t('not-found-data')"
                class="tree-select-height-css tree-select-filter-modal"
              />
            </b-col>
          </template>
          <template v-else-if="filter.TypeShow.toUpperCase() == 'CHECKBOX'">
            <b-col xl="4" lg="4" md="12" class="mb-3" :key="index">
              <p class="font-weight-bold text-small mb-2">{{ filter.Title }}</p>
              <template v-if="filter.TypeCheck.toUpperCase() == 'SINGLE'">
              </template>
              <template
                v-else-if="filter.TypeCheck.toUpperCase() == 'MULTIPLE'"
              >
                <b-form-checkbox-group
                  class="fix-checkbox"
                  v-model="filterForm[filter.TableName]"
                  :options="filterData[filter.TableName]"
                  size="sm"
                  plain
                  stacked
                  style="
                    max-height: 300px;
                    overflow-y: auto;
                    overflow-x: hidden;
                  "
                ></b-form-checkbox-group>
              </template>
            </b-col>
          </template>
        </template>
        <b-col xl="12" lg="12" md="12">
          <b-button
            class="float-right btn-readmore py-2 px-4"
            size="sm"
            variant="success"
            @click="actionFilter"
            >Tìm kiếm</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";

import { server } from "@/constants/config";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import Map from "./components/Map.vue";
import SideBar from "@/layout/SidebarMap.vue";
import RouteDetail from "./components/RouteDetail.vue";
import StationDetail from "./components/StationDetail.vue";
import RepositoryFactory from "@/repository/factory";
import { recursiveTreeselect } from "@/utils";

const busGetMapNow = RepositoryFactory.get("busGetMapNow");
const greeneryTreeDataCurrents = RepositoryFactory.get(
  "greeneryTreeDataCurrents"
);
const SystemGuestComments = RepositoryFactory.get("SystemGuestComments");

export default {
  components: {
    Map,
    SideBar,
    RouteDetail,
    StationDetail,
    TreeSelect,
  },
  async created() {
    await this.getMapNow();
    await this.getMapNowWFS();
  },
  watch: {
    direction(to) {
      if (to === false) {
        this.dataByID.RouteDetails.forEach((e, i) => {
          if (e.Direction === 0) {
            this.lines = JSON.parse(e.StringPoint);
          }
        });
        this.listStationOnLine = this.dataByID.StopDetails.filter(
          (e) => e.Direction === 0
        );
        this.listBusStop = this.dataByID.StopDetails.filter(
          (e) => e.Direction === 0
        ).sort((a, b) => {
          return a.STT - b.STT;
        });
      } else {
        this.dataByID.RouteDetails.forEach((e, i) => {
          if (e.Direction === 1) {
            this.lines = JSON.parse(e.StringPoint);
          }
        });
        this.listStationOnLine = this.dataByID.StopDetails.filter(
          (e) => e.Direction === 1
        );
        this.listBusStop = this.dataByID.StopDetails.filter(
          (e) => e.Direction === 1
        ).sort((a, b) => {
          return a.STT - b.STT;
        });
      }
    },
  },
  data() {
    return {
      isHide: false,
      listRoutes: [],
      listRoutesFilter: [],
      isHideScroll: true,
      currentTab: 0,
      dataByID: null,
      search: "",
      direction: false,
      listBusStop: [],
      directionName: "",
      listTree: [],
      listTreeFilter: [],
      stationDetail: null,
      listRouteOfStation: [],
      listBusOfStation: [],
      lines: [],
      listStationOnLine: [],
      focus: null,
      itemPerView: 10,
      filterCode: null,
      filterFormat: null,
      filterData: null,
      filterForm: null,
      listComment: [],
      serverName: server,
      cqlFilter: null,
      isLoading: true,

      timer: null,
    };
  },

  methods: {
    handleFilter() {},
    async getListComment(id) {
      let body = {
        ServerName: server,
        OID: id.toString(),
        GeoCode: "TREE",
      };
      let res = await SystemGuestComments.GetByOID(body);
      this.listComment = res.status ? res.data : [];
    },
    limitText(count) {
      return `và ${count} lựa chọn khác`;
    },
    async filterModal(code) {
      this.filterCode = code;
      const response = await greeneryTreeDataCurrents.GetMapNow_Filter({
        ServerName: server,
      });
      this.filterFormat = response.status
        ? response.data?.length > 0
          ? response.data[0].DataProperties
          : null
        : null;
      let value = {};
      let options = {};
      if (this.filterFormat?.length > 0) {
        this.filterFormat.forEach((x) => {
          switch (x.TypeShow.toUpperCase()) {
            case "TABLE":
              value[x.TableName] = null;
              options[x.TableName] = x.FilterDatas;
              break;
            case "TREETABLE":
              break;
            case "SELECT":
              value[x.TableName] = null;
              options[x.TableName] =
                x.FilterDatas?.length > 0
                  ? x.FilterDatas.map((y) => ({
                      text: y.Name,
                      label: y.Name,
                      value: y.ID,
                    }))
                  : null;
              break;
            case "TREESELECT":
              let array = [];
              if (x.FilterDatas?.length > 0) {
                recursiveTreeselect(
                  x.FilterDatas,
                  0,
                  array,
                  "ParentID",
                  "ID",
                  "Counting",
                  "Name"
                );
              }
              options[x.TableName] = array;
              break;
            case "CHECKBOX":
              value[x.TableName] =
                x.TypeCheck.toUpperCase() == "SINGLE"
                  ? false
                  : x.TypeCheck.toUpperCase() == "MULTIPLE"
                  ? []
                  : null;
              options[x.TableName] =
                x.FilterDatas?.length > 0
                  ? x.FilterDatas.map((y) => ({
                      text: y.Name,
                      label: y.Name,
                      value: y.ID,
                    }))
                  : null;
              break;
            default:
              break;
          }
        });
      }
      if (!this.filterForm) this.filterForm = value;
      this.filterData = options;
      this.$nextTick(() => {
        this.$bvModal.show("modal-filter-result");
      });
    },
    recursiveTreeselectRouteName(
      defaultArray,
      parentID,
      resultArray,
      parentKey,
      childrenKey,
      value = null
    ) {
      if (!defaultArray || defaultArray?.length == 0) return;
      defaultArray.forEach((element) => {
        if (element[parentKey] != parentID) return;
        let newArray = [];
        this.recursiveTreeselectRouteName(
          defaultArray,
          element[childrenKey],
          newArray,
          parentKey,
          childrenKey,
          value
        );
        let object = {};
        if (!newArray || newArray?.length == 0) {
          object = {
            id: element[childrenKey],
            parent: element[parentKey],
            label:
              value && element[value] > 0
                ? `${element["TreeRouteName"]} (${element[value]})`
                : element["TreeRouteName"],
          };
        } else {
          object = {
            id: element[childrenKey],
            parent: element[parentKey],
            label:
              value && element[value] > 0
                ? `${element["TreeRouteName"]} (${element[value]})`
                : element["TreeRouteName"],
            children: newArray,
          };
        }
        resultArray.push(object);
      });
    },
    findValueAndChildren(rootNode, resultArray) {
      if (!rootNode.children || rootNode.children.length == 0) {
        resultArray.push(rootNode.id);
        return;
      }
      for (const childNode of rootNode.children) {
        this.findValueAndChildren(childNode, resultArray);
      }
    },
    getDataMapByLayer(selected, filter = null) {
      this.getMapNow(filter);
    },
    async actionFilter() {
      this.isLoading = true;
      let array = [];
      let cqlFilterString = "";
      let queries = [];
      for (const [key, value] of Object.entries(this.filterForm)) {
        let object = {
          GeoCode: "TREE",
          TableName: key,
          ID: value.join(","),
        };
        array.push(object);
        if (value && value != "") {
          if (key.toUpperCase() == "TREEROUTES") {
            const _response = await greeneryTreeDataCurrents.GetMapNow_Filter({
              ServerName: server,
            });
            const _result = _response.status
              ? _response.data?.length > 0
                ? _response.data[0].DataProperties
                : null
              : null;
            const _filterResult = _result
              ? _result.filter((x) => x.TableName == key)
              : null;
            if (_filterResult?.length > 0) {
              const _data = _filterResult[0].FilterDatas;
              let _array = [];
              if (_data?.length > 0) {
                for (const val of value) {
                  recursiveTreeselect(
                    _data,
                    val,
                    _array,
                    "ParentID",
                    "ID",
                    "Counting",
                    "Name"
                  );
                }
              }
              let _resultArray = [];
              if (_array?.length > 0) {
                for (const _val of _array) {
                  this.findValueAndChildren(_val, _resultArray);
                }
              }
              const batchSize = 50;
              for (let i = 0; i < _resultArray.length; i += batchSize) {
                const batch = _resultArray.slice(i, i + batchSize);
                const queryPart = batch.join(",");
                queries.push(`${key} IN (${queryPart})`);
              }
            }
          } else {
            if (cqlFilterString != "") {
              cqlFilterString += "AND ";
            }
            cqlFilterString += `${key} IN (${value.join(", ")}) `;
          }
        }
      }
      let cqlFilterNew = [];
      if (queries?.length > 0) {
        for (const query of queries) {
          if (cqlFilterString != "") {
            cqlFilterNew.push(`${query} AND ${cqlFilterString}`);
          } else {
            cqlFilterNew.push(query);
          }
        }
      } else {
        if (cqlFilterString != "") {
          cqlFilterNew.push(cqlFilterString);
        }
      }
      this.cqlFilter = cqlFilterNew;
      await this.getMapNow(array);
      this.$bvModal.hide("modal-filter-result");
      if (this.listTree.length) {
        this.flytoPointMap(
          {
            Lat: parseFloat(this.listTree[0].Lat),
            Long: parseFloat(this.listTree[0].Long),
          },
          false
        );
      }
    },
    resetPopupDataFilter() {
      // this.filterCode = null;
      // this.filterFormat = null;
      // this.filterData = null;
      // this.filterForm = null;
    },
    handleReadMore() {
      this.itemPerView = this.itemPerView + 10;
    },
    mapClick(value) {
      value.ID = value.ID;
      this.getBusStopDetail(value);
    },
    async getBusStopDetail(value) {
      let body = {
        StopID: value.StopID ? value.StopID : value.StationID,
      };
      let res = await busGetMapNow.GetBusStopDetail(body);
      this.stationDetail = value;
      this.listRouteOfStation = res.status ? res.data[0] : null;
      this.listBusOfStation = res.status ? res.data[1] : null;
      this.focus = value;
      this.mergeListBusAndStation(
        res.status ? res.data[0] : null,
        res.status ? res.data[1] : null
      );
      this.currentTab = 2;
    },
    mergeListBusAndStation(value, value2) {
      this.listRouteOfStation.forEach((item, index) => {
        let arr = [];
        this.listBusOfStation.forEach((e, i) => {
          if (item.RouteID === e.RouteID) {
            arr.push(e);
          }
        });
        item.listBus = arr.sort((a, b) => {
          return a.WaitingTime - b.WaitingTime;
        });
      });
    },
    async getMapNow(filter = null) {
      let body = {
        ServerName: server,
        MapFilter: filter,
      };
      let res = await greeneryTreeDataCurrents.GetMapNow(body);
      this.isLoading = false;
      this.listTree = res.status ? res.data : [];
      this.listTreeFilter = res.status ? res.data : [];
    },
    async getMapNowWFS() {
      const response = await greeneryTreeDataCurrents.GetMapNow_Filter({
        ServerName: server,
      });
      const data = response.status
        ? response.data?.length > 0
          ? response.data[0]?.DataProperties
          : null
        : null;
      const filterData =
        data?.length > 0
          ? data.filter((x) => x.TableName.toUpperCase() == "TREEROUTES")
              ?.length > 0
            ? data.filter((x) => x.TableName.toUpperCase() == "TREEROUTES")[0]
            : null
          : null;
      if (filterData?.FilterDatas?.length > 0) {
        let value = [];
        filterData.FilterDatas.forEach((x) => {
          if (
            !filterData.FilterDatas.filter((y) => y.ParentID == x.ID)?.length >
            0
          ) {
            value.push(x.ID);
          }
        });
        const batchSize = 50;
        const queries = [];
        for (let i = 0; i < value.length; i += batchSize) {
          const batch = value.slice(i, i + batchSize);
          const queryPart = batch.join(",");
          queries.push(`TreeRoutes IN (${queryPart})`);
        }
        this.cqlFilter = queries;
      }
    },
    handleSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let arr = [...this.listTree];
        let filter = arr.filter(
          (e) =>
            e.StationName.toUpperCase().includes(this.search.toUpperCase()) ||
            e.ConcatAddress.toUpperCase().includes(this.search.toUpperCase())
        );
        this.listTreeFilter = filter;
      }, 500);
    },
    async getDetail(value) {
      this.getListComment(value);
      let body = {
        ServerName: server,
        StationID: value.toString(),
      };
      let res = await greeneryTreeDataCurrents.GetMapNow_ByID(body);
      this.dataByID = res.status ? res.data[0] : null;
      this.currentTab = 1;
    },
    actionChange(action, value) {
      switch (action) {
        case "TAB":
          this.currentTab = value;
          break;
        case "DIRECT":
          this.direction = !this.direction;
          break;
      }
    },
    flytoPointMap(item, HL) {
      if (this.$refs.mapContainer) {
        this.$refs.mapContainer.flyToPoint(item.Lat, item.Long, HL);
      }
    },
    pointClickOnMap(item) {
      this.getDetail(item.StationID);
    },
  },
};
</script>
<style>
.fix-checkbox input {
  margin: 0 -25px 0 0 !important;
  position: relative;
}

.modal-radius {
  border-radius: 16px !important;
}
</style>
<style scoped>
.btn-readmore {
  border-radius: 12px;
  background: var(--Brand, #029834);
}

.btn-readmore:focus {
  border-radius: 12px;
  background: var(--Brand, #029834);
}

.btn-readmore:hover {
  border-radius: 12px;
  background: var(--Brand, #029834);
}

.btn-filter {
  height: 40px;
  width: 45px !important;
  border-radius: 12px;
  background: var(--Brand, #029834);
  padding: 8px;
  margin: 0 0 0 16px;
  text-align: center;
  cursor: pointer;
}

.btn-filter:hover {
  height: 40px;
  width: 45px !important;
  border-radius: 12px;
  background: var(--Brand, #029834);
  padding: 8px;
  margin: 0 0 0 16px;
  text-align: center;
  cursor: pointer;
}

.img-frame {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  background-repeat: no-repeat, repeat;
  background-position: center;
  /* Center the image */
  background-size: cover;
  /* Resize the background image to cover the entire container */
}

.header-tab {
  padding: 24px 16px 16px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(25px);
  width: 100%;
  position: absolute;
  z-index: 1;
}

.content-tab {
  /* 58px là thanh nav */
  height: calc(100vh - 64px);
  overflow: auto !important;
  scrollbar-width: 20px !important;
  padding: 190px 11px 0;
}

/* .content-tab:hover {
  height: calc(100vh - 58px - 121px);
  overflow: scroll !important;
  padding-right: 11px;
} */
.content-tab::-webkit-scrollbar {
  width: 5px;
  position: absolute !important;
  transition: transform 0.3s;
}

.content-tab::-webkit-scrollbar-thumb {
  visibility: hidden;
}

.content-tab:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}

.detail-btn {
  color: var(--website-brand-color, #029834);
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.4px;
  cursor: pointer;
}

.router-name {
  color: var(--labels-primary, #000);
  margin-bottom: 8px !important;
  /* Medium-16/L150/16 - Bold */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  /* 24px */
  letter-spacing: -0.31px;
  display: block;
}

.router-info {
  display: block;
  color: var(--label-color-primary, #000);
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.4px;
}

.time-info {
  color: var(--label-color-primary, #000);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.4px;
}

.item-card {
  border-radius: 12px;
  /* border: 1px solid var(--bottom-bar-border-inactive, #ebebf0); */
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  background: var(--system-background-primary, #fff);
  padding: 16px;
  margin-bottom: 16px;
  transition: 0.5s;
}

.item-card:hover {
  border-radius: 12px;
  /* border: 1px solid var(--bottom-bar-border-inactive, #ebebf0); */
  background: var(--system-background-primary, #fff);

  /* elevation-2 */
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
}

.tab-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.07px;
}

.tabs {
  margin: 24px 16px;
}

.text-color {
  color: var(--website-brand-color, #029834);
}

.search {
  position: absolute;
  top: calc(58px + 24px) !important;
  left: 24px;
  z-index: 2;
  transition: transform 0.3s ease-in-out;
  transform: translateX(396px);
}

.map-container {
  width: 100vw;
  position: absolute;
  top: 64px;
}

.side-bar {
  position: absolute;
  z-index: 1;
  top: 64px;
  left: 0;
  transition: transform 0.3s ease-in-out;
}

.is-visible {
  transform: translateX(-396px);
}

.is-visible-search {
  transform: translateX(0px);
}

#nlt {
  stroke: #e3282c;
  stroke-width: 3px;
  fill: transparent;
}
</style>
